module.exports = __webpack_public_path__ + "static/media/video_drop.9b2e9f5f.png";